var render = function render(){var _vm=this,_c=_vm._self._c;return _c('display',{staticClass:"m-b-15",attrs:{"model_name":_vm.model_name},scopedSlots:_vm._u([{key:"table_right_options",fn:function(props){return [_vm._t("table_right_options",null,{"model":props.model})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }